import { Locale } from 'services/language-service';
import { BaseEntity } from '../BaseEntity';
import { CreateUpdateMooringFrameSalesOrderDetails, MooringFrameSalesOrderDetails } from './MooringFrameSalesOrderDetails';
import { CreateUpdateMooringFrameSalesOrderLine, MooringFrameSalesOrderLineListItem } from './MooringFrameSalesOrderLine';
import { MooringSalesOrderLineListItem, CreateUpdateMooringSalesOrderLine } from './MooringSalesOrderLine';
import { CertificateSendType } from 'components/dialogs/send-certificates-choice/send-certificates-choice-dialog';

export const AquacomSyncStatus = {
  NOT_SYNCED: 1,
  SYNC_FAILED: 2,
  SYNCED: 3,
} as const;

export type AquacomSyncStatus = (typeof AquacomSyncStatus)[keyof typeof AquacomSyncStatus];

export class MooringSalesOrder extends BaseEntity {
  static ApiUrl = 'api/mooring-sales-orders';

  ApprovedBy?: string;
  ApprovedById?: string;
  ApprovedAt?: Date;

  CertificateId?: number;
  CertificatesZipId?: number;

  Locale: Locale;

  CustomerId: number;
  CustomerName: string;

  ContactId: number;
  ContactName: string;

  SiteId: number;
  SiteName: string;

  TypeId: number;

  OrderNumber: string;
  InvoiceNumber: string;

  OrderLines: MooringSalesOrderLineListItem[];

  FrameOrderLines: MooringFrameSalesOrderLineListItem[];
  FrameOrderDetails?: MooringFrameSalesOrderDetails;

  AquacomSyncStatus?: AquacomSyncStatus;
  AquacomSyncedAt?: Date;
  CanSyncToAquacom: boolean;

  Note?: string;

  DeliveryDate?: Date;
  SentFromId?: number;
  SendToEmailAddress?: string;
  SentToEmailAddressAt?: Date;
}

export class CreateUpdateMooringSalesOrder {
  Id?: number;

  CustomerId: number;
  ContactId: number;
  SiteId: number;
  OrderNumber: string;
  InvoiceNumber: string;

  Locale: Locale;

  TypeId?: number;

  OrderLines: CreateUpdateMooringSalesOrderLine[];

  Note?: string;

  DeliveryDate?: Date;
  SentFromId?: number;
  SendToEmailAddress?: string;
  SentToEmailAddressAt?: Date;

  FrameOrderLines: CreateUpdateMooringFrameSalesOrderLine[];
  FrameOrderDetails?: CreateUpdateMooringFrameSalesOrderDetails;
}

export class MooringSalesOrderListItem {
  Id: number;
  CertificatesZipId?: number;
  ApprovedAt?: Date;
  CustomerName: string;
  LocalityName: string;
  OrderNumber: string;
  InvoiceNumber: string;
  ContactName: string;
  ContactEmail?: string;
  Note?: string;
  SentFromName?: string;

  AquacomSyncStatus?: AquacomSyncStatus;

  OrderLines: MooringSalesOrderLineListItem[];
  FrameOrderLines: MooringFrameSalesOrderLineListItem[];
}

export class SendMooringSalesOrderCertificateToMe {
  Id: number;
  OrderNumber: string;
  SenderName: string;
  RecipientEmail: string;
  LocalityId?: number;
  CertificatesZipId: number;
  SendType: CertificateSendType;
}

export class SendMooringSalesOrderCertificateToCustomer {
  Id: number;
  OrderNumber: string;
  SenderEmail: string;
  SenderName: string;
  RecipientEmail: string;
  LocalityId?: number;
  CertificatesZipId: number;
  SendType: CertificateSendType;
}
